// @ts-nocheck
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Grid,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { createLocalization } from "../../../features/localization";

const AddLocalization = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    language: "en",
    key: "",
    value: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    if (!formData.key || !formData.value) {
      toast.error("Key and Value are required.");
      return;
    }

    dispatch(createLocalization(formData))
      .then((resultAction) => {
        if (createLocalization.rejected.match(resultAction)) {
          console.error(resultAction.payload || resultAction.error);
          toast.error("An error occurred while creating the localization.");
        } else {
          toast.success("Localization created successfully!");
          navigate("/localization");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("An error occurred while creating the localization.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />

      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Localization
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Language Select */}
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={formData.language}
                onChange={handleChange}
                IconComponent={KeyboardArrowDownIcon}
                fullWidth
                size="small"
                sx={{
                  height: "40px !important",
                  ".MuiSelect-select": {
                    padding: "0px 8px !important",
                    height: "40px !important",
                  },
                }}
              >
                <MenuItem value="en">English</MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>

          {/* Key Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Key
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="key"
              placeholder="Enter the localization key"
              value={formData.key}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Value Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Value
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="value"
              placeholder="Enter the localized value"
              value={formData.value}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton variant="gradient" color="info" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddLocalization;
